import * as images from '../../assets/coursesImages.export';

const COURSES_DATA = {
  courses: [
    {
      id: 1,
      title: 'CS246: Object-Oriented Software Development',
      link: 'https://cs.uwaterloo.ca//current/courses/course_descriptions/cDescr/newCDescr/CS246',
      icon: images.uwaterlooIcon,
      languages: ['C++'],
      tools: ['Git', 'Linux', 'Bash'],
      grade: '96%',
      description: 'Learned object-oriented programming with C++ by developing complex programs through weekly assignments and lectures. Used a Linux server for assignments which taught me Git and Bash commands.',
    },
    {
      id: 2,
      title: 'CS136: Elementary Algorithm Design and Data Abstraction',
      link: 'https://cs.uwaterloo.ca/current/courses/course_descriptions/cDescr/CS136',
      icon: images.uwaterlooIcon,
      languages: ['C'],
      tools: [],
      grade: '98%',
      description: 'Learned imperative programming and memory management with C by developing complex programs through weekly assignments and lectures.',
    },
    {
      id: 3,
      title: 'CS135: Designing Functional Programs',
      link: 'https://cs.uwaterloo.ca/current/courses/course_descriptions/cDescr/CS135',
      icon: images.uwaterlooIcon,
      languages: ['Scheme (Racket)'],
      tools: [],
      grade: '95%',
      description: 'Learned functional programming with Racket by developing complex programs through weekly assignments and lectures.',
    },
  ]
}

export default COURSES_DATA;
